const viewportValue = () => {
  if (window.innerWidth < 576) {
    return 'xs';
  } else if (window.innerWidth >= 576 && window.innerWidth < 992) {
    return 'sm';
  } else if (window.innerWidth >= 992 && window.innerWidth < 1200) {
    return 'md';
  }

  return 'lg';
};


export const isViewport = (breakpoint) => {
  switch (breakpoint) {
    case 'xs':
      return window.innerWidth < 576;
    case 'sm':
      return window.innerWidth >= 576 && window.innerWidth < 992;
    case 'md':
      return window.innerWidth >= 992 && window.innerWidth < 1200;
    case 'lg':
      return window.innerWidth >= 1200;
    default:
      return null;
  }
};

export const viewport = () => ({
  value: viewportValue(),
  is: isViewport
});

export const lessThanLargeDevice = !viewport().is('lg');

export const largeDevice = viewport().is('lg');


export default {
  viewport
};



// WEBPACK FOOTER //
// ./src/utils/client.js